import React from 'react'
import { Wrapper } from 'src/ui/layout'
import { styled, useTheme } from 'src/ui/theme'
import { BLOCK_DATA } from './constants'
import { Body, Header } from 'src/ui/typography'

const BlocksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`

const Block = styled.div<{ isLast?: boolean }>`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;

  background-color: ${({ isLast, theme }) =>
    isLast ? theme.colors.brand.primary : theme.colors.gray.bg};
`

export type Props = {}

export const Blocks = ({}: Props) => {
  const theme = useTheme()
  return (
    <Wrapper>
      <BlocksContainer>
        {BLOCK_DATA.map((item, index) => {
          const isLast = index === BLOCK_DATA.length - 1

          return (
            <Block key={item.title} isLast={isLast}>
              <Header
                as="h2"
                size="h2"
                color={
                  isLast
                    ? theme.colors.white.primary
                    : theme.colors.brand.primary
                }
              >
                {item.title}
              </Header>
              <Body
                color={
                  isLast
                    ? theme.colors.white.primary
                    : theme.colors.black.secondary
                }
              >
                {item.body}
              </Body>
            </Block>
          )
        })}
      </BlocksContainer>
    </Wrapper>
  )
}
